import { render, staticRenderFns } from "./HeroBranding.vue?vue&type=template&id=94473d0e&scoped=true&"
import script from "./HeroBranding.vue?vue&type=script&lang=js&"
export * from "./HeroBranding.vue?vue&type=script&lang=js&"
import style0 from "./HeroBranding.vue?vue&type=style&index=0&id=94473d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94473d0e",
  null
  
)

export default component.exports